var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-12",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","md":"11","sm":"12","lg":"10"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }